/* eslint-disable */
import React, { useState, useEffect } from "react";
import { getMyAccountId } from "../../utils/config";
import { getLogoUrl } from "../../utils/config";

const MYACCOUNT_ID = getMyAccountId();

const slides = [
  {
    type: "image",
    bg: "https://www.ultra-erp.pro/logos/ecommerce.png",
    title: "Business",
    highlight: "moves fast",
    text: "Stay ahead and make sure your teams have what they need to tackle what's ahead.",
    button: "New arrivals",
  },
  {
    type: "solid",
    bgImage: getLogoUrl("ecommerce-bg-1", true),
    overlay: "linear-gradient(90deg, rgba(236,52,60,0.30) 0%, rgba(0,0,0,0.45) 60%, rgba(0,0,0,0.65) 100%)",
    logo: `https://www.ultra-erp.pro/logos/${MYACCOUNT_ID}_1.png`,
    text: "Todo lo que necesitas en un solo proveedor",
    textColor: "text-[#ffffff]",
  },
  {
    type: "solid",
    bgImage: getLogoUrl("ecommerce-bg-2", true),
    // overlay: "linear-gradient(90deg, rgba(23,32,72,0.30) 0%, rgba(0,0,0,0.45) 60%, rgba(0,0,0,0.65) 100%)",
    logo: `https://www.ultra-erp.pro/logos/${MYACCOUNT_ID}_2.png`,
    text: "Todo lo que necesitas en un solo proveedor",
    textColor: "text-[#172048]", 
  },


];

export default function HeroBanner() {
  const [index, setIndex] = useState(0);

  const next = () => setIndex((i) => (i + 1) % slides.length);
  const prev = () => setIndex((i) => (i - 1 + slides.length) % slides.length);

  useEffect(() => {
    const id = setInterval(next, 6000);
    return () => clearInterval(id);
  }, []);

  return (
    <div
      className="
        relative w-full
        h-[280px]
        sm:h-[380px]
        md:h-[500px]
        lg:h-[600px]
        xl:h-[720px]
        overflow-hidden
      "
    >

      {slides.map((s, i) => (
        <div
          key={i}
          className={`absolute inset-0 transition-opacity duration-700 ${i === index ? "opacity-100 z-10" : "opacity-0 z-0"
            }`}
        >
       {s.type === "image" && (
  <>
    <div
      className="absolute inset-0"
      style={{
        backgroundImage: `url(${s.bg})`,
        backgroundRepeat: "no-repeat",
        // CAMBIOS AQUÍ:
        backgroundSize: "cover",      // 'cover' hace que ocupe todo el ancho/alto
        backgroundPosition: "center", // Centra la imagen para que no se corte feo
      }}
    />
    {/* Overlay para mejorar la legibilidad del texto */}
    <div className="absolute inset-0 bg-black/20" />

              {/* ESCALA POR BREAKPOINT (MISMO LAYOUT SIEMPRE) */}
              <div
                className="
                  absolute top-[40%] -translate-y-1/2
                  left-[-35px] md:left-[35px]
                  transform
                  scale-[0.55] sm:scale-[0.7] md:scale-[0.85] lg:scale-100
                  origin-left
                "
              >
                {/* CÍRCULO */}
                <div
                  className="
                    w-[570px] h-[570px]
                    bg-brand-primary
                    rounded-full
                    flex items-center
                  "
                >
                  {/* CONTENIDO (DESKTOP-BASE) */}
                  <div className="pt-1 pl-28 pr-20 text-white">
                    <h1 className="-mt-24 text-[72px] font-light leading-[1.2]">
                      {s.title}
                      <br />
                      <span className="block -mt-8">{s.highlight}</span>
                    </h1>

                    <p className="text-[25px] mt-3 font-bold max-w-[470px]">
                      {s.text}
                    </p>

                    <button
                      className="
                        mt-6
                        border border-white
                        px-6 py-2
                        text-sm
                        hover:bg-white
                        hover:text-[#ec343c]
                        transition
                      "
                    >
                      {s.button}
                    </button>
                  </div>
                </div>
              </div>
            </>
          )}

          {s.type === "solid" && (
            <div
              className="relative w-full h-full flex items-center justify-center px-6 bg-cover"
              style={{
                backgroundImage: `url(${s.bgImage})`,
                backgroundPosition: "50% 30%",
              }}
            >

              {/* overlay */}
              <div
                className="absolute inset-0"
                style={{ background: s.overlay }}
              />

              {/* contenido intacto */}
              <div className="relative max-w-5xl w-full flex items-center justify-between z-10">
                <img
                  src={s.logo}
                  alt="logo"
                  className="
                      h-36 md:h-44 lg:h-56
                      min-h-[180px] md:min-h-[220px] lg:min-h-[280px]
                      w-auto object-contain
                    "
                />
                {s.text && (
                  <h2
                    className={`
                      ${s.textColor || "text-white"}
                      text-4xl md:text-5xl
                      font-bold
                      max-w-xl
                    `}
                  >
                    {s.text}
                  </h2>
                )}
              </div>
            </div>
          )}

        </div>
      ))}

      {/* FLECHAS */}
      <button
        onClick={prev}
        className="absolute left-4 top-1/2 -translate-y-1/2 z-20 bg-white/70 hover:bg-white px-3 py-2"
      >
        ‹
      </button>
      <button
        onClick={next}
        className="absolute right-4 top-1/2 -translate-y-1/2 z-20 bg-white/70 hover:bg-white px-3 py-2"
      >
        ›
      </button>

      {/* DOTS */}
      <div className="absolute bottom-4 left-1/2 -translate-x-1/2 flex gap-2 z-20">
        {slides.map((_, i) => (
          <button
            key={i}
            onClick={() => setIndex(i)}
            className={`w-3 h-3 rounded-full ${i === index ? "bg-black" : "bg-black/40"
              }`}
          />
        ))}
      </div>
    </div>
  );
}
